import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { selectTooltipTextByKey } from '../state/core.selectors';

@Pipe({
    name: 'tooltip',
    pure: true,
    standalone: false
})
export class TooltipPipe implements PipeTransform {
    constructor(private store: Store) {}

    transform(key: string): Observable<string> {
        return this.store.select(selectTooltipTextByKey(key));
    }
}
